<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-warehouse fa-fw"
                            placeholder="Selecione o Local..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            optionsName="estoque_locals.index.sup"
                            :optionsParm="{ sup: 1 }"
                            v-model="filtros.id_estoque_local"
                            @input="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Todos os Fornecedores..."
                            icon="fas fa-store"
                            type="autocomplete"
                            optionsMode="aql"
                            service="fornecedores.index"
                            optionsData="id_fornecedor"
                            optionsDisplay="search"
                            v-model="filtros.id_fornecedor">
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fab fa-google fa-fw"
                            placeholder="Todos os Grupos..."
                            type="select"
                            service="estoque_grupos.index"
                            optionsData="id_estoque_grupo"
                            optionsMode="aql"
                            v-model="filtros.id_estoque_grupo" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Todos o itens..."
                            icon="fa-solid fa-box fa-fw"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="estoque_items.index"
                            :optionsSync="false"
                            optionsData="id_estoque_item"
                            v-model="filtros.id_estoque_item" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input 
                            icon="fa fa-search" 
                            placeholder="Pesquisar..."
                            v-model="filtros.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" :disabled="!filtros.id_estoque_local" type="button" @click="incluir()" data-toggle="tooltip" data-placement="left" title="Incluir movimentação.">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                    <a href="#" @click.prevent="emitir_etiqueta()" class="btn btn-outline-primary" data-toggle="tooltip" data-placement="left" title="Imprimir etiquetas.">
                                        <i class="fas fa-tags fa-fw"></i>
                                    </a>
                                    <print-export printid="lista-impressao" :left="true" pagina="suprimentos-movimentacoes" :parms="parms_relatorios" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>        

        <az-empty-state v-if="!lista.length" msg="Nenhuma movimentação identificada." />

        <template v-else>
            <div id="lista-impressao">
                <cabecalho-generico :titulo="titulo" />

                <div class="card carde mb-2 w3-animate-opacity" v-for="(mov, inx) in lista" :key="inx">
                    <div class="card-body py-1">
                        <div class="row" >
                            <div class="col col-12 col-md-2">
                                <small>
                                    {{ mov.local.search }}
                                </small>
                                <div>
                                    #{{ mov.id_estoque_movimentacao }}
                                    <span v-if="mov.st_doc">
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ mov.st_doc }}
                                    </span>
                                </div>
                            </div>
                            <div class="col col-12 col-md-2">
                                <small v-if="mov.tipo">
                                    {{ mov.tipo.search }}
                                </small>
                                <div>
                                    <small>
                                        {{ $util.getFormatDate(mov.dt_movimentacao) }}
                                        {{ mov.dt_movimentacao.substr(11,5) }}
                                    </small>
                                </div>
                            </div>
                            <div class="col col-12 col-md-4">
                                <div v-if="mov.fornecedor">
                                    {{ mov.fornecedor.search }}
                                </div>
                                <div>
                                    <small>
                                        {{ mov.item.search }} 
                                    </small>
                                    <span class="badge badge-secondary ml-2">
                                        #{{ mov.id_estoque_item }}
                                    </span>
                                    <div v-if="mov.st_observacao" class="small text-muted">
                                        {{ mov.st_observacao }}
                                    </div>
                                </div>
                            </div>
                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                <div>
                                    <div>
                                        <i class="fa fa-plus-circle text-success mr-1" aria-hidden="true" v-if="mov.in_fator_saldo > 0"></i>
                                        <i class="fa fa-minus-circle text-danger mr-1" aria-hidden="true" v-else-if="mov.in_fator_saldo < 0"></i>
                                        {{ mov.in_quantidade }} 
                                        <small class="text-muted">{{ mov.item.st_unidade_estoque }}</small>
                                        <small class="text-muted ml-3" v-if="mov.st_lote && mov.st_lote != 'Sem Lote'">Lote: {{ mov.st_lote }}</small>
                                    </div>
                                    <div>
                                        {{ $util.formatMoeda(mov.in_quantidade * mov.dc_valor) }}
                                    </div>
                                </div>

                                <!-- Menu de opções -->
                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <button class="dropdown-item" @click="cancelar_movimentacao(mov)">
                                            Cancelar Movimentação
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </template>

        <!-- Modal -->
        <div class="modal fade" id="movimentarAddModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fa fa-plus-circle text-success mr-2" aria-hidden="true" v-if="tipo && tipo.fl_entrada"></i>
                            <i class="fa fa-minus-circle text-danger mr-2" aria-hidden="true" v-else-if="tipo && !tipo.fl_entrada"></i>
                            {{ titulo }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-row mb-3">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Documento"
                                    required
                                    :validate="validate"
                                    v-model="doc" />
                            </div>

                            <div class="col col-12 col-md-6" v-if="tipo && tipo.fl_info_fornecedor">
                                <az-input
                                    sizing="sm"
                                    label="Fornecedor"
                                    required
                                    :validate="validate"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="fornecedores.index"
                                    optionsData="id_fornecedor"
                                    optionsDisplay="search"
                                    v-model="id_fornecedor">
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-3" v-if="tipo && tipo.fl_info_valor">
                                <az-input
                                    sizing="sm"
                                    label="Valor Total"
                                    :edicao="false"
                                    :value=" $util.formatMoeda(valor_total) " />
                            </div>
                        </div>

                        <template v-for="(material, imx) in lista_items">
                            <div class="form-row" :key="imx" v-if="true">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        :edicao="false"
                                        v-model="material.item.search">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger btn-sm" type="button" id="button-addon1" @click="remover_item(material)">
                                                    <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">#{{ material.item.id_estoque_item }}</span>
                                            </div>
                                        </template>
                                    </az-input>
                                    <div class="mb-3" v-if="material.lote">
                                        <small class="text-muted ml-3">
                                            Lote: {{ material.lote.st_lote }} / Validade: {{ $util.getFormatDate(material.lote.dt_validade) }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="number"
                                        required 
                                        :validate="validate"
                                        v-model="material.in_quantidade">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <span class="input-group-text small" id="basic-addon2">
                                                    {{ material.item.st_unidade_estoque }}    
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2" v-if="tipo && tipo.fl_info_valor">
                                    <az-input
                                        :compact="true"
                                        label="Preço"
                                        :key="'m' + imx"
                                        :type="removendo ? 'number' : 'money'"
                                        sizing="sm"
                                        placeholder="Valor..."
                                        :validate="validate"
                                        v-model="material.dc_valor" />
                                </div>
                                <div class="col col-12" :class="( tipo && tipo.fl_info_valor ) ? 'col-md-2' : 'col-md-4'">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Observação..."
                                        v-model="material.st_observacao" />
                                </div>
                            </div>
                        </template>

                        <selecao-material 
                            @selecionado="incluir_item" 
                            :id_estoque_local="filtros.id_estoque_local" 
                            :entrada="tipo ? tipo.fl_entrada : false" 
                            :infoqt="true" />

                        <br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <estoque-etiqueta ref="estoque_etiqueta" :sufixo="'mov_esp' + id" />

        <!-- Conclusão -->
        <div class="modal fade" id="conclusaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Movimentação Realizada</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="id_movs && id_movs.length">
                        <div class="alert alert-info">
                            {{ id_movs.length }} movimentação(ões) realizada(s).
                        </div>

                        <relatorios-linkados 
                            pagina="suprimentos-movimentacoes" 
                            :apenas_links="true" 
                            :parms="{ movimentacao_id: id_movs }" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import SelecaoMaterial from './SelecaoMaterial';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import RelatoriosLinkados from '../../relatorios/shared/RelatoriosLinkados.vue'

export default {
    data() { 
        return { 
            search: "",
            viewMode: "S", 
            dados: [],
            firstload: false,
            montando: true, 
            filtros: { 
                inicio: this.$util.hoje(),
                fim: this.$util.hoje(),           
                id_estoque_local: this.$util.getCookie('estoque-armazem'),
                periodo: "s",
                id_estoque_item: "",
                id_estoque_grupo: "",
                id_fornecedor: "",
                search: "", 
            },
            titulo: "...",
            tipo: null, 
            movimentacoes: [], 
            doc: null, 
            id_fornecedor: null, 
            validate: false, 
            removendo: false, 
            id_movs: [], 
        }
    },

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit, 
        AzPeriodo, 
        SelecaoMaterial, 
        EstoqueEtiqueta, 
        PrintExport,
        CabecalhoGenerico, 
        RelatoriosLinkados, 
    },

    computed: { 
        parms_relatorios: function () { 
            if ( !this.lista ) { 
                return {};
            }

            return { 
                movimentacao_id: this.lista.map(item => item.id_estoque_movimentacao),
            };
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.filtros.search);

            return this.dados.filter(item => !this.filtros.search || reg.test(JSON.stringify(item)));
        },

        lista_items: function () { 
            if ( !this.movimentacoes )
                return [];

            return this.movimentacoes.filter(item => item.fl_ativo);
        },

        valor_total: function () { 
            return this.lista_items.reduce((total, carry) => total + parseFloat(carry.dc_valor * carry.in_quantidade), 0);
        },
    },

    props: ['id'],

    methods: { 
        cancelar_movimentacao (mov) { 

            if ( !confirm('Confirma cancelar a movimentação #' + mov.id_estoque_movimentacao + '?') )
                return;

            this.$util.atualizar(this, { 
                service: "estoque",
                func: "cancelar_movimentacao",
                dados: { 
                    id_estoque_movimentacao: mov.id_estoque_movimentacao, 
                },
                toast: true,
                reload: true, 
            });

        },

        emitir_etiqueta() {
            const etiquetaItens = this.lista.map(mov => {
                    return {
                        checked: false,
                        id_estoque_item: mov.id_estoque_item,
                        lote: (mov.item && mov.item.fl_controla_lote) ? mov.st_lote : null,
                        validade: (mov.item && mov.item.fl_controla_lote && mov.lote) ? mov.lote.dt_validade : null,
                        qtde: mov.in_quantidade,
                        search:  mov.item.search,
                    }
                });

            this.$refs.estoque_etiqueta.show(etiquetaItens);
        },

        remover_item(material) { 
            this.removendo = true;
            
            this.$nextTick(() => { 
                material.fl_ativo = false
                this.removendo = false;
            });
        },

        incluir_item(novo) { 
            if ( !novo )
                return;

            let numero_lote = _.get(novo, 'lote.item') ? _.get(novo, 'lote.item.st_lote') : _.get(novo, 'lote.numero');

            let busca = this.movimentacoes.find(item => item.fl_ativo 
                && item.item.id_estoque_item == novo.id_estoque_item
                && ( !item.item.fl_controla_lote || _.get(item, 'lote.st_lote') == numero_lote ) );

            if ( busca ) { 
                busca.in_quantidade = parseInt(busca.in_quantidade) + parseInt( novo.quantidade ? novo.quantidade : 1 );
                return; 
            }

            let lote = _.get(novo, 'lote.item') 
                ? _.get(novo, 'lote.item') 
                : ( 
                    _.get(novo, 'lote.numero') 
                        ? { 
                            st_lote: _.get(novo, 'lote.numero'),
                            dt_validade: _.get(novo, 'lote.validade')
                        } 
                        : null
                 ) ;

            if ( !novo.fl_controla_lote ) { 
                lote = null;
            }

            this.movimentacoes.push({ 
                id_estoque_movimentacao: null, 
                id_estoque_item: null, 
                id_estoque_local: this.filtros.id_estoque_local, 
                id_estoque_tipo_movimentacao: this.id, 
                item: _.cloneDeep(novo), 
                in_quantidade: novo.quantidade ? novo.quantidade : 1,
                fl_pendente: true, 
                st_observacao: "", 
                fl_ativo: true, 
                lote: lote, 
            });
        },

        incluir() { 
            this.validate = false;
            this.doc = "";
            this.id_fornecedor = "";
            this.movimentacoes = [];

            $('#movimentarAddModal').modal('show');
        },

        atualizar() { 

            if ( !this.movimentacoes || !this.movimentacoes.filter(item => item.fl_ativo).length ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione o material.",
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, { 
                service: "estoque",
                func: "outros_movimentar",
                dados: { 
                    movs: this.movimentacoes,
                    id_estoque_tipo_movimentacao: this.id, 
                    doc: this.doc, 
                    id_fornecedor: this.id_fornecedor, 
                },
                modal: 'movimentarAddModal',
                reload: true, 
                callback: res => { 
                    if ( res && res.id_movs && res.id_movs.length ) { 
                        this.id_movs = res.id_movs;

                        this.$nextTick(() => { 
                            $('#conclusaoModal').modal('show');
                        });
                    }
                }
            });

        },

        load() { 
            if ( this.montando )
                return;

            if ( !this.id ) { 
                console.log('Tipo de movimentação não definido.');
            } else { 
                //console.log('Outra Mov', this.id);
            }

            this.$util.load(this, { 
                service: 'estoque_movimentacoes',
                parms: { 
                    ...this.filtros, 
                    where: { 
                        id_estoque_tipo_movimentacao: this.id, 
                    }
                }
            });
        },
    },

    mounted() { 
        this.$util.loadItem(this, { 
            service: 'estoque_tipo_movimentacaos',
            id: this.id, 
        })
        .then(res => { 
            this.tipo = res; 
            this.titulo = res.search;

            this.$store.commit("setBreadcrumb", [
                { name: "Suprimentos", path: "/suprimentos" },
                { name: res.search, path: "/suprimentos/mov-" + res.id_estoque_tipo_movimentacao }
            ]);
        });

        this.$nextTick(() => { 
            this.montando = false;
            this.load();
        });
    }
}
</script>